import React from 'react';
import './InfoCt1.css';

const InfoCt1 = props => {
  const names = props.data.names.map(name => (
    <div key={encodeURIComponent(name[0])} className="name-wrap">
      <h4>{name[0]}</h4>
      <h5>{name[1]}</h5>
    </div>
  ));

  const thanks = props.data.thanks.names.map(thank => {
    if (thank.indexOf('.cz') !== -1) {
      return (
        <a
          key={encodeURIComponent(thank)}
          className="thank"
          href={`http://www.${thank}`}
          target="_blank"
        >
          {thank}
        </a>
      );
    }
    return (
      <div key={encodeURIComponent(thank)} className="thank">
        {thank}
      </div>
    );
  });

  return (
    <div id="info-ct-1" className="info-block">
      {names}
      <h4>{props.data.thanks.title}</h4>
      {thanks}
    </div>
  );
};

export default InfoCt1;



// WEBPACK FOOTER //
// ./src/components/App/Dukla/ProjectInfo/InfoCt1/InfoCt1.js